"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekMs = exports.DayMs = exports.HourMs = exports.MinuteMs = exports.SecondMs = void 0;
exports.SecondMs = 1000;
exports.MinuteMs = 60 * exports.SecondMs;
exports.HourMs = 60 * exports.MinuteMs;
exports.DayMs = 24 * exports.HourMs;
exports.WeekMs = 7 * exports.DayMs;
// NO OTHERS!
// eg, do NOT add MonthMs or YearMs constants. They're too ambiguous. If needed, use date methods to get actual periods. eg date.getMonth()
//# sourceMappingURL=time-ms.js.map